module.exports = __webpack_public_path__ + "assets/img/00173.d4b6cbad.png";